<template>
	<div id="search-controls" v-if="show">
		<div id="status" class="col-sm-2 colspan-1">
			<label>{{ $t('item.status') }}</label>
			<br>
			<div v-for="(value, key) in statuses" :key="key" class="status-filter-element" :data-name="value.status">
				{{ value.status }}
				<button class="complete-status" tabindex="-1"></button>
				<button class="draft-status" tabindex="-1"></button>
			</div>
		</div>

		<template v-for="(attr, key) in filterAttributes">
			<div v-if="(attr.type === 'SL') || (attr.type === 'S') || (attr.type === 'N')" :id="key" class="col-sm-2 colspan-1">
				<label>{{ $t(attr.title) }}</label>
				<br>
				<input class="textInput">
				<button class="button_reset fa fa-times" tabindex="-1"></button>
				<button class="button_multiple-switcher fa fa-arrow-down" tabindex="-1"></button>
			</div>
			<div v-if="attr.type === 'B'" :id="key" class="col-sm-2 colspan-1">
				<label>{{ $t(attr.title) }}</label>
				<br>
				<select tabindex="-1" class="select attribute-editor">
					<option value="any">{{ $t('any') }}</option>
					<option value="true">{{ $t('true') }}</option>
					<option value="false">{{ $t('false') }}</option>
				</select>
			</div>
			<div v-if="attr.type === 'NM'" :id="key" class="col-sm-2">
				<label>{{ $t(attr.title) }}</label>
				<br>
				<select class="select-split attribute-editor">
					<option value="any">{{ $t('any') }}</option>
					<option v-for="(value, key) in measurementUnits[attr.measurementUnitType]"
							:key="key" :value="key">{{ $t(value) }}
					</option>
				</select>
				<input type="text" class="textInput-split attribute-editor">
				<button class="button_reset fa fa-times"></button>
			</div>
			<div v-if="attr.type === 'L'" :id="key" class="multicheckbox-filter col-sm-2 colspan-1">
				<label>{{ $t(attr.title) }}</label>
				<br>
				<div class="attribute-editor mcb-drop-down-wrapper">
					<div class="mcb-drop-down-btn fa fa-list-ul"></div>
					<div class="value-list"></div>
				</div>
				<div class="mcb-item-list">
					<div class="mcb-controls">
						<div class="mcb-clear blank"></div>
						<input class="mcb-search " type="text">
						<button class="button_reset fa fa-times" tabindex="-1"></button>
					</div>
					<ul class="checkbox-list mcb-filter-list">
						<li v-for="(value, key) in classificators[attr.classificatorType]" :key="key">
							<input class="attribute-editor bg-editor" type="checkbox" :value="key"/>{{ $t(value) }}
						</li>
					</ul>
					<ul class="checkbox-sublist mcb-filter-list"></ul>
				</div>
			</div>
			<div v-if="attr.type === 'D'" :id="key" class="col-sm-2 colspan-1">
				<label>{{ $t(attr.title) }}</label>
				<br>
				<div class="datepicker-range input-daterange input-group">
					<input type="text" class="textInput input-sm form-control attribute-editor" name="start">
					<span class="input-group-addon">-</span>
					<input type="text" class="textInput input-sm form-control" name="end" tabindex="-1">
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { initRangeDatepicker } from '@/core/input_controls/datepicker/datepicker'

export default {
	name: 'Filter-table',
	props: [
		'dbFilter',
		'itemStructure',
		'classificators',
		'measurementUnits',
		'show',
	],
	data () {
		return {
			statuses: this.$store.getters.getDraftCount,
			baseFilterAttributes: {
				created: {
					title: 'item.first.version.date.create',
					type: 'D'
				},
				updated: {
					title: 'item.updated',
					type: 'D'
				},
				id: {
					title: 'item.id',
					type: 'S'
				},
				creator: {
					title: 'item.creator',
					type: 'S'
				},
				updater: {
					title: 'item.updater',
					type: 'S'
				}
			}
		}
	},
	computed: {
		filterAttributes () {
			let res = {}
			this.dbFilter.forEach(attr => {
				if (this.itemStructure[attr]) {
					res[attr] = this.itemStructure[attr]
				}
				if (this.baseFilterAttributes[attr]) {
					res[attr] = this.baseFilterAttributes[attr]
				}
			})
			return res
		}
	},
	mounted () {
		initRangeDatepicker()
	}
}
</script>

<style scoped>

</style>
